const formatter = new Intl.RelativeTimeFormat('en-US', {
  numeric: 'always',
  style: 'long',
});

export const relativeDate = (date: Date | string) => {
  date = new Date(date);
  const diff = date.getTime() - Date.now();

  const seconds = diff / 1000;
  const minutes = seconds / 60;
  const hours = minutes / 60;
  if (hours > -24) return formatter.format(+hours.toFixed(0), 'hours');
  const days = hours / 24;
  if (days > -31) return formatter.format(+days.toFixed(0), 'days');
  const months = days / 31;
  if (months > -12) return formatter.format(+months.toFixed(0), 'months');
  const years = months / 12;
  return formatter.format(+years.toFixed(0), 'years');
};
